import React, { useState } from 'react';
import { startPasswordReset, verifyPasswordReset } from '../api/usuarios';
import { useNavigate } from 'react-router-dom';
import { useNotify } from '../components/NotificationProvider';

const initialForm = {
  email: '',
  code: '',
  newPassword: '',
  confirmPassword: ''
};

const RestorePassword = () => {
  const [form, setForm] = useState(initialForm);
  const [err, setErr] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setErr('');
  };

  const { success: notifySuccess, error: notifyError } = useNotify();

  // Paso 1: Enviar código al correo
  const [step, setStep] = useState(1);

  const handleSendCode = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      const res = await startPasswordReset(form.email);
      if (res?.success) {
        notifySuccess('Código enviado. Revisa tu correo (válido 15 minutos).');
        setStep(2);
      } else {
        const m = res?.error || 'No se pudo enviar el código';
        setErr(m);
        notifyError(m);
      }
    } catch (err) {
      const m = err?.message || 'Error de red';
      setErr(m);
      notifyError(m);
    }
  };

  // Paso 2: Verificar código y cambiar contraseña
  const handleVerifyAndChange = async (e) => {
    e.preventDefault();
    setErr('');
    if (form.newPassword !== form.confirmPassword) {
      setErr('Las contraseñas no coinciden');
      return;
    }
    try {
      const res = await verifyPasswordReset({
        email: form.email,
        code: form.code,
        newPassword: form.newPassword
      });
      if (res?.success) {
        setForm(initialForm);
        notifySuccess('Contraseña actualizada, inicia sesión');
        navigate('/');
      } else {
        const m = res?.error || 'No fue posible actualizar la contraseña';
        setErr(m);
        notifyError(m);
      }
    } catch (err) {
      const m = err?.message || 'Error de red';
      setErr(m);
      notifyError(m);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-8 rounded-xl shadow-lg mt-12">
      <h2 className="text-2xl font-bold mb-6 text-center">Restablecer contraseña</h2>

      {step === 1 && (
        <form onSubmit={handleSendCode} className="space-y-3">
          <p className="text-sm text-gray-600">Ingresa tu correo y te enviaremos un código de verificación.</p>
          <input
            type="email"
            name="email"
            placeholder="Correo"
            value={form.email}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />
          {err && <div className="text-red-500 text-center">{err}</div>}
          <button
            type="submit"
            className="w-full py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold rounded-xl"
          >
            Enviar código
          </button>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handleVerifyAndChange} className="space-y-3">
          <p className="text-sm text-gray-600">Hemos enviado un código a tu correo. Ingrésalo a continuación y escribe tu nueva contraseña.</p>
          <input
            type="text"
            name="code"
            placeholder="Código de 6 dígitos"
            value={form.code}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded tracking-widest"
            required
          />
          <input
            type="password"
            name="newPassword"
            placeholder="Nueva contraseña"
            value={form.newPassword}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirmar nueva contraseña"
            value={form.confirmPassword}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />
          {err && <div className="text-red-500 text-center">{err}</div>}
          <div className="flex gap-3">
            <button type="button" onClick={() => setStep(1)} className="px-4 py-2 rounded-xl bg-gray-200 text-gray-700 hover:bg-gray-300">Atrás</button>
            <button
              type="submit"
              className="flex-1 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold rounded-xl"
            >
              Restablecer
            </button>
          </div>
        </form>
      )}

    </div>
  );
};

export default RestorePassword;
